<template>
  <LineDiff
    :before="formatDiffVal(before)"
    :after="formatDiffVal(after)"
    left-label="Old"
    right-label="New"
  />
</template>

<script setup lang="ts">
import LineDiff from '../../components/LineDiff.vue'

defineProps<{
  before: unknown
  after: unknown
}>()

// Show only real differences (ignoring JSON key order)
function sortKeysDeep(v: unknown): unknown {
  if (Array.isArray(v)) return v.map(sortKeysDeep)
  if (v !== null && typeof v === 'object') {
    const sorted: Record<string, unknown> = {}
    for (const k of Object.keys(v as Record<string, unknown>).sort()) {
      sorted[k] = sortKeysDeep((v as Record<string, unknown>)[k])
    }
    return sorted
  }
  return v
}

function formatDiffVal(v: unknown) {
  if (v === null || v === undefined) return ''
  if (typeof v === 'string') return v
  try {
    return JSON.stringify(sortKeysDeep(v), null, 2)
  } catch {
    return String(v)
  }
}
</script>
